export default __webpack_public_path__ + "static/media/votuza_logo_final.a2df9b2e.png";